import { SxProps } from "@mui/system";

const textSize = "1rem";
const iconSize = "1.5rem";
const inputPaddingY = "0.375rem";

export const actionBarSxContentOnly: SxProps = {
	"& > *": {
		maxHeight: "2.25rem",
	},
	"& .MuiInputBase-root": {
		fontSize: textSize,
		flex: 1,
		"& .MuiInputBase-input": {
			paddingY: inputPaddingY,
		},
	},
	"& .MuiInputLabel-root": {
		fontSize: textSize,
		"&:not(.MuiInputLabel-shrink)": {
			transform: `translate(14px, ${inputPaddingY}) scale(1)`,
		},
	},
	"& .MuiAutocomplete-root": {
		display: "flex",
		"& > .MuiTextField-root": {
			flex: 1,
		},
		"& .MuiInputBase-root": {
			paddingY: 0,
			"& .MuiInputBase-input": {
				paddingY: inputPaddingY,
			},
		},
	},
	"& .MuiButton-root": {
		paddingY: inputPaddingY,
		minHeight: "2rem",
		paddingX: "0.5rem",
		fontSize: "0.875rem",
		"& .MuiTypography-root": {
			fontSize: "0.875rem",
			lineHeight: textSize,
		},
		"& .MuiButton-startIcon": {
			"& > svg": {
				fontSize: "1.2rem",
			},
		},
	},
	"& .MuiIconButton-root": {
		fontSize: iconSize,
		paddingX: 0.75,
		paddingY: 0.5,
	},
};

export const actionBarSx: SxProps = {
	display: "flex",
	alignSelf: "flex-start",
	alignItems: "stretch",
	flexWrap: "wrap",
	padding: 0.5,
	paddingTop: 1,
	gap: 0.5,
	...actionBarSxContentOnly,
};
